import React from "react";
import Header from "../components/Header";
import TagMeetingAttendanceBox from "../components/TagMeetingAttendanceBox";

const Meetings = () => {
  return (
    <div >
      <Header /> <TagMeetingAttendanceBox />
    </div>
  );
};

export default Meetings;
